var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarkAsRead = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0088bb",
    d: "M990,470L990,470c0-0.2-0.1-0.4-0.1-0.6c0.1-3.8-0.6-7.6-1.9-11.1c-1.8-9-4.8-17.4-10.2-24.5h0.2l-0.9-0.8c-3.2-4.1-6.8-7.8-10.9-11l-160-161.1v-98.9c0-16.9-13.7-30.6-30.7-30.6h-97L566.9,35.9c-34.7-34.7-95.2-34.7-129.9,0l-111.5,95.4H224.3c-16.9,0-30.7,13.7-30.7,30.6v100.8L37.6,418.9c-16.5,11-27.6,29.8-27.6,51v459c0,33.6,27.6,61.2,61.3,61.2h857.5c33.6,0,61.2-27.6,61.2-61.2V471.1C990,470.8,990,470.4,990,470z M267.4,704.3l-196.1,182v-355L267.4,704.3z M326.5,733c4-1.8,7.7-4.3,10.9-7.8c1.3-1.5,1.8-3.3,2.9-4.9l133.2-123.6c6.9-5.6,15.1-8.5,23.8-8.5c8.8,0,17.6,3.1,23.5,7.6l367.4,333H115.3L326.5,733z M735.8,708.4l193-171.2v346.1L735.8,708.4z M869.4,408.8h-1l52.6,53.4L806.2,564V345.6L869.4,408.8z M480.3,79.2c5.8-5.7,13.5-9,21.6-9c8.2,0,15.9,3.2,21.7,9l61.9,52.2H418.4L480.3,79.2z M745,192.5v425.8l-54.8,48.6L559.7,548.7c-36.1-28.3-87.9-29.5-126,1.3L312.5,662.5L255,611.8V192.5H745z M109.4,433.8l84.4-84.4v208.2L82.1,459.2l25.8-25.4H109.4z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarkAsRead);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/markAsRead.e4887ff616888be4621e819b931e4d7d.svg";